import React from 'react';
import './skeleton.css';

const VARIANT_CLASS = {
  bar: 'sk-block--bar',
  circle: 'sk-block--circle',
  pill: 'sk-block--pill',
};

/**
 * Primitive shimmer block. Decorative — always aria-hidden.
 */
export default function SkeletonBlock({
  variant = 'bar',
  width,
  height,
  className = '',
  style,
}) {
  const resolvedStyle = { ...style };
  if (width != null) resolvedStyle.width = typeof width === 'number' ? `${width}px` : width;
  if (height != null) resolvedStyle.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <span
      className={`sk-block ${VARIANT_CLASS[variant] || VARIANT_CLASS.bar} ${className}`.trim()}
      style={resolvedStyle}
      aria-hidden="true"
    />
  );
}
